import React, { useReducer, createContext, useContext } from "react";

const initialState = { web3Instance: null, walletProvider: null };

const reducer = (state, action) => {
  switch (action.type) {
    case "SAVE_WEB3_INSTANCE":
      return action.data;
    default:
      return state;
  }
};

export const CurrentWeb3Context = createContext({});

export const CurrentWeb3Provider = ({ children }) => {
  const [web3Instance, dispatchWeb3Instance] = useReducer(
    reducer,
    initialState
  );
  return (
    <CurrentWeb3Context.Provider value={{ web3Instance, dispatchWeb3Instance }}>
      {children}
    </CurrentWeb3Context.Provider>
  );
};

export const useCurrentWeb3Context = () => useContext(CurrentWeb3Context);
